<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'融资租赁公司列表',goback:true},{name:'融资租赁公司明细'}]" :title="'融资租赁公司明细'"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="融资租赁公司详情" name="1"></el-tab-pane>
              <el-tab-pane label="申请记录" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" v-show="tab==='2'" ref='condition'>
                <div class="left">
                    <div class="child">
                        <span class="name">申请结果</span>
                        <el-select v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 主体 -->
            <!-- 产品详情 -->
            <div class="box super_boxs" v-show="tab==='1'">
              <el-card class="basic box_card" header="" shadow="never">
              <div class="basisTitle">基本信息：</div>
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">公司名称：</div>
                    <div class="content">{{detailInfo.companyName}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                     <div class="child">
                    <div class="name">分类：</div>
                    <div class="content">{{detailInfo.companyName}}</div>
                </div>
                  </el-col>
                  </el-row>
                <el-row>
                  <el-col :span="24">
                     <div class="child">
                    <div class="name">LOGO：</div>
                    <div class="content"><img class="logos" :src="detailInfo.frontPath+detailInfo.logoUrl" /></div>
                </div>
                  </el-col>
                </el-row>
                <el-row>
                  
                  <el-col :span="24">
                     <div class="child">
                    <div class="name">公司简介：</div>
                    <div class="content contentword">{{detailInfo.remarks}}</div>
                </div>
                  </el-col>
                  </el-row>
                <el-row>
                  <el-col :span="24">
                     <div class="child">
                    <div class="name">融资租赁说明：</div>
                    <ul style="line-height: 20px;">
                        {{detailInfo.explanation}}
                    </ul>
                </div>
                  </el-col>
                  </el-row>
                <el-row>
                  <el-col :span="24">
                     <div class="child">
                    <div class="name">附件：</div>
                    <ul class="content">
                        <li v-for="(item,index) in detailInfo.fileList" :key="index">
                            <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                        </li>
                    </ul>
                </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="" shadow="never">
                <div class="basisTitle">其它信息：</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">发布账号：</div>
                    <div class="content">{{detailInfo.createUserName}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">发布时间：</div>
                    <div class="content">{{detailInfo.createTime}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">更新账号：</div>
                    <div class="content">{{detailInfo.modifyUserName}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">更新时间：</div>
                    <div class="content">{{detailInfo.updateTime}}</div>
                </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    
                    label="申请结果">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" v-show="tab==='2'" ref='pagination'>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                custom-class="super_dialog"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{tableDetail.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{tableDetail.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{tableDetail.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.dealWithRemark}}</div>
                        </div>
                        <div class="child">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in tableDetail.fileList" :key="index">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="opens(item)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{tableDetail.createTime}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">申请结果信息</div>
                        <div class="child">
                            <div class="name">申请结果：</div>
                            <div class="content">{{tableDetail.rateValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.applyRemark}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{tableDetail.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{tableDetail.updateTime}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        breadcrumb
    },
    data(){
        return{
          loading:false,
          bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '申请人姓名'
            }, {
                value: '4',
                label: '联系方式'
            }],//检索下拉
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                loanId:"",
                rate:'',//申请结果
                userName:"",//账号
                contactPhone:'',//手机号
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            detailInfo:{
                companyName:'',//公司名称
                classifyValue:'',//分类
                logoUrl:"",
                remarks:"",//公司简介
                explanation:'',//融资租赁说明
                fileList:[],
                userName:'',//发布账号
                createTime:"",//发布时间
                modifyUserName:'',//更新人账户
                updateTime:"",//修改时间
            },
            statusList:[],
            totalSize:null,
            tableDetail:{
                applicant:"",//申请人姓名：
                contactPhone:"",//联系手机号：
                applyCompany:"",//公司全称：
                dealWithRemark:"",//说明：
                fileList:[],//附件
                createTime:"",//提交时间：
                checkStatusValue:"",//申请结果：
                applyRemark:"",//申请说明：
                modifyUserName:"",//更新账号：
                updateTime:"",//更新时间：
            }
        }
    },
    methods:{
      opens({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
       },
      onReset(){
        const param = {
          currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                loanId:this.id,//申请id
                rate:'',//进度
                userName:"",//账号
                contactPhone:'',//手机号
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
                endDate:null,//结束时间
                startDate:null,//开始时间
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,param)
        this.getSelect = void 0
        this.getValue = void 0
        this.dateS = []
        this.getData()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // 切换选项啦
        changeTab:function(tab){
            const that = this
            that.tab=tab.name
            that.getData()
            if(tab.name === '2'){
              setTimeout(() => {
                that.$nextTick(() => {
                  let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
              }, 200);
              
            }
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //查看明细
        check:function(row){
            this.dialogInfo=true;
            this.$axiosc.get('backstage/financial/leasing/apply/details/'+row.id).then(res=>{
                if(res.code == 200){
                    this.tableDetail = res.data
                    if(this.tableDetail.fileList.length > 0){
                        if(!this.tableDetail.fileList[0].frontPath){
                            let value = []
                            this.tableDetail.fileList.map(val=>{
                                value.push({fileName:val.fileName,filePath:val.filePath,frontPath:this.tableDetail.frontPath})
                            })
                            this.tableDetail.fileList = value
                        }
                    }
                }else{
                    this.$alert(res.msg)
                }
            })
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
          this.loading = true
            if(this.tab === '1'){
                this.$axiosz.get('backstage/financial/leasing/details/'+this.id).then(res=>{
                   this.loading = false
                    if(res.code == 200){
                        this.detailInfo = res.data 
                        if(this.detailInfo.fileList.length > 0){
                        if(!this.detailInfo.fileList[0].frontPath){
                            let value = []
                            this.detailInfo.fileList.map(val=>{
                                value.push({fileName:val.fileName,filePath:val.filePath,frontPath:this.detailInfo.frontPath})
                            })
                            this.detailInfo.fileList = value
                        }
                    }
                    }
                }).catch(e=>{
                  this.loading = false
                })
            }else{
                if(this.dateS&&this.dateS.length>0){
                    this.sendInfoOne.startDate=this.dateS[0];
                    this.sendInfoOne.endDate=this.dateS[1];
                }else{
                    this.sendInfoOne.startDate=null;
                    this.sendInfoOne.endDate=null;
                }
                this.sendInfoOne.id="";//申请id
                this.sendInfoOne.userName='';//账号
                this.sendInfoOne.name='';//姓名
                this.sendInfoOne.applicant='';//申请人姓名
                if(this.getSelect=='1'){ //申请id
                    this.sendInfoOne.id=this.getValue;
                }else if(this.getSelect=='2'){ //账号
                    this.sendInfoOne.userName=this.getValue;
                }else if(this.getSelect=='3'){ //申请人姓名
                    this.sendInfoOne.applicant=this.getValue;
                }else if(this.getSelect=='4'){ //联系手机号
                    this.sendInfoOne.contactPhone=this.getValue;
                }
                this.$axiosc.get('backstage/financial/leasing/apply/createId/list',{params:this.sendInfoOne}).then(res=>{
                  this.loading = false
                    if(res.code == 200){
                        this.tableData = res.data.content
                        this.totalSize=res.data.totalElements;
                    }
                }).catch(e=>{
                  this.loading = false
                })
            }
        },
        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/isShow/FINANCIAL_LEASING_RATE').then((r)=>{ //审核结果
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
        },
    },
    created(){
        if(this.$route.query.id){
            this.id=this.$route.query.id;
        }
    },
    mounted(){
        const that = this
        that.getDic()
        let query = this.$route.query
        if(query){
            that.id = that.$route.query.id
            that.sendInfoOne.loanId = that.id
            that.getData()
        }
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
        
    }
}
</script>

<style lang="scss" scoped>

.super_boxs{
 height:calc(100% - 110px);
  overflow-x: hidden;
  overflow-y: auto;
}
.warp{
    height:calc(100% - 20px);
    padding:10px 20px;
    .detailBas{
        margin-top: 20px;
        
    }
    .tab{
            width: 110px!important;
        }
}
.box{
    margin-top: 20px;
    &_card{
      border:none ;
      
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:0 !important;
        }
      }
    }
    .childMulti{
      margin-top:0 !important;
      margin-bottom: 10px;
    }
    .child{
      margin-bottom:10px;
      .name{
      width:80px;
      text-align: right;
    }
    }
    .attachment{
      margin-bottom:10px;
    }
    .basisTitle{
      margin-bottom:10px;
    }
}
.boxChild{
  .basisTitle{
    margin-bottom:10px
  }
  .child{
    margin-bottom:10px;
    .name{
      width:80px;
      text-align: right;
    }
  }
}
</style>